enum ProductGroup {
    CablesCubage = 'cable',
    InvertersCubage = 'inverter',
    ModulesCubage = 'module',
    StructuresCubage = 'structure',
}

export default ProductGroup;
